/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../simple_instrument_store/model';
import '../privacyvault/annotations';
import './online_store';
import './app_data';
import '../common/identity_keys';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "person": {
        "nested": {
          "Person": {
            "fields": {
              "personToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "createdAtMs": {
                "type": "int64",
                "id": 2,
                "rule": "optional"
              },
              "updatedAtMs": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "retiredAtMs": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "previousPersonToken": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "DO_NOT_USEAlias": {
                "type": "string",
                "id": 6,
                "rule": "repeated"
              },
              "profile": {
                "type": ".squareup.person.Profile",
                "id": 7,
                "rule": "optional"
              },
              "activeInstrument": {
                "type": ".squareup.simple_instrument_store.Instrument",
                "id": 8,
                "rule": "repeated"
              },
              "scopedAlias": {
                "type": ".squareup.person.Alias",
                "id": 9,
                "rule": "repeated"
              },
              "vaultedData": {
                "type": ".squareup.privacyvault.VaultedData",
                "id": 10,
                "rule": "optional"
              }
            }
          },
          "Profile": {
            "fields": {
              "version": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": ".squareup.person.Profile.Name",
                "id": 2,
                "rule": "optional"
              },
              "imageUrl": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "primaryEmailAlias": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "primaryPhoneAlias": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "onlineStoreOptions": {
                "type": ".squareup.person.online_store.OnlineStoreOptions",
                "id": 7,
                "rule": "optional"
              },
              "appData": {
                "type": ".squareup.person.app_data.AppData",
                "id": 8,
                "rule": "optional"
              },
              "tinFideliusToken": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "personSecrets": {
                "type": ".squareup.person.PersonSecrets",
                "id": 10,
                "rule": "optional"
              },
              "encryptedPersonSecrets": {
                "type": "bytes",
                "id": 11,
                "rule": "optional"
              },
              "preferredLocale": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "timeZone": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "personVaultedData": {
                "type": ".squareup.privacyvault.VaultedData",
                "id": 14,
                "rule": "optional"
              },
              "identityKeys": {
                "type": ".squareup.common.identitykeys.IdentityKeys",
                "id": 15,
                "keyType": "string"
              },
              "unclaimed": {
                "type": "bool",
                "id": 16,
                "rule": "optional"
              },
              "creatorApplicationId": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 18,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "int64",
                "id": 19,
                "rule": "optional"
              }
            },
            "nested": {
              "Name": {
                "fields": {
                  "full": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "first": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "middle": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "last": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "PersonSecrets": {
            "fields": {
              "dateOfBirth": {
                "type": ".squareup.common.time.YearMonthDay",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "Alias": {
            "fields": {
              "type": {
                "type": ".squareup.person.Alias.AliasType",
                "id": 1,
                "rule": "optional"
              },
              "scope": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "value": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "firstVerifiedAtMs": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "lastVerifiedAtMs": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "int64",
                "id": 7,
                "rule": "optional"
              }
            },
            "nested": {
              "AliasType": {
                "values": {
                  "UNKNOWN": 0,
                  "EMAIL": 1,
                  "PHONE": 2,
                  "PAN_FIDELIUS": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.person?.nested?.Person && !$root.nested?.squareup?.nested?.person?.nested?.Profile && !$root.nested?.squareup?.nested?.person?.nested?.Profile?.nested?.Name && !$root.nested?.squareup?.nested?.person?.nested?.PersonSecrets && !$root.nested?.squareup?.nested?.person?.nested?.Alias && !$root.nested?.squareup?.nested?.person?.nested?.Alias?.nested?.AliasType) {
  $root.addJSON(jsonData);
}

/**
 * next id = 10
 *
 * SOURCE Person @ squareup/person/service.proto at 38:1
 */
export const Person = $root.lookupType('squareup.person.Person');
fixType(Person);
Builder.createAndAttachToType(Person);
/**
 * Profile is the primary content we store about a person.
 *
 * A profile has common content and product (role) specific sections:
 * E.g. name and image URL are common.
 *
 * SOURCE Profile @ squareup/person/service.proto at 125:1
 */
export const Profile = $root.lookupType('squareup.person.Profile');
fixType(Profile);
Builder.createAndAttachToType(Profile);
/**
 * We won't always have structured first and last name.
 * In some cases first/last doesn't internationalize well.
 * Alternatively, a person might be a business and the name on the receipt needs to be the
 * business name for tax purposes.
 *
 * Either a full name or first/last names must be set - potentially both are set.
 * All other fields are optional.
 *
 * SOURCE Name @ squareup/person/service.proto at 204:3
 */
Profile.Name = $root.lookupType('squareup.person.Profile.Name');
fixType(Profile.Name);
Builder.createAndAttachToType(Profile.Name);
/**
 * SOURCE PersonSecrets @ squareup/person/service.proto at 287:1
 */
export const PersonSecrets = $root.lookupType('squareup.person.PersonSecrets');
fixType(PersonSecrets);
Builder.createAndAttachToType(PersonSecrets);
/**
 * An alias is an identifier for a Person
 *
 * SOURCE Alias @ squareup/person/service.proto at 295:1
 */
export const Alias = $root.lookupType('squareup.person.Alias');
fixType(Alias);
Builder.createAndAttachToType(Alias);
/**
 * SOURCE AliasType @ squareup/person/service.proto at 296:3
 */
Alias.AliasType = $root.lookupEnum('squareup.person.Alias.AliasType').values;